import { t as _objectSpread2 } from "./objectSpread2-CtW7yo8J.js";
import { n as isAppleDevice, t as ACTION_KEY_DEFAULT } from "./keyboard-BkSdCzTU.js";
import { t as _objectWithoutProperties } from "./objectWithoutProperties-mN58NJZT.js";
import { t as SparklesIcon } from "./SparklesIcon-D0XWamV3.js";
import React, { useEffect, useState } from "react";

//#region src/Sidepanel/SidepanelButton.tsx
const _excluded = [
	"variant",
	"keyboardShortcuts",
	"translations"
];
const SidepanelButton = (_ref) => {
	let { variant = "floating", keyboardShortcuts, translations = {} } = _ref, props = _objectWithoutProperties(_ref, _excluded);
	const { buttonText = "Ask AI", buttonAriaLabel = "Ask AI" } = translations;
	const [key, setKey] = useState(null);
	useEffect(() => {
		if (typeof navigator !== "undefined") isAppleDevice() ? setKey("⌘") : setKey(ACTION_KEY_DEFAULT);
	}, []);
	const actionKeyAltText = key === "Ctrl" ? "Control" : "Meta";
	const isCtrlCmdIEnabled = (keyboardShortcuts === null || keyboardShortcuts === void 0 ? void 0 : keyboardShortcuts["Ctrl/Cmd+I"]) !== false;
	const shortcut = `${actionKeyAltText}+i`;
	return /* @__PURE__ */ React.createElement("button", _objectSpread2(_objectSpread2({
		className: `DocSearch-SidepanelButton ${variant}`,
		type: "button",
		"aria-label": isCtrlCmdIEnabled ? `${buttonAriaLabel} (${shortcut})` : buttonAriaLabel,
		"aria-keyshortcuts": isCtrlCmdIEnabled ? shortcut : void 0
	}, variant === "floating" ? { tabIndex: -1 } : {}), props), /* @__PURE__ */ React.createElement(SparklesIcon, null), variant !== "floating" && buttonText);
};

//#endregion
export { SidepanelButton };
//# sourceMappingURL=sidepanelButton.js.map